import {
    LIST_RESULT_TYPES,
    LIST_RESULT_TYPES_SUCCESS,
    LIST_RESULT_TYPES_ERROR,
    ADD_RESULT_TYPES,
    SAVE_RESULT_TYPES,
    SAVE_RESULT_TYPES_SUCCESS,
    SAVE_RESULT_TYPES_ERROR,
    DELETE_RESULT_TYPES,
    DELETE_RESULT_TYPES_SUCCESS,
    DELETE_RESULT_TYPES_ERROR,
    EDIT_RESULT_TYPES,
    UPDATE_RESULT_TYPES,
    UPDATE_RESULT_TYPES_SUCCESS,
    UPDATE_RESULT_TYPES_ERROR
} from '../types';

import clienteAxios from '../config/axios';
import authToken from '../config/token';

import resultTypesData from '../data/resultTypes';
import { ErrorMessage, WaitingMessage, SuccessMessage } from '../components/extras/toastMessages';
import { MSG_DELETING, MSG_CREATE_SUCCESS, MSG_UPDATE_SUCCESS, MSG_DELETE_SUCCESS } from '../constants/messages';
import Swal from 'sweetalert2';
import { METHOD_DISABLED } from '../constants/requestMethods';

const controller = 'resultado';

//LISTAR AUDIENCE MOTIVES
export function listResultTypesAction(params) {
    return async (dispatch) => {
        //Inicializo
        dispatch( listResultTypes() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.get(`/${controller}`, { params });
            //Obtengo los datos
            const resultTypes = response.data;
            //const resultTypes = resultTypesData;
            //Llamo al dispatch
            dispatch( listResultTypesSuccess(resultTypes.content) );
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( listResultTypesError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const listResultTypes = () => ({
    type: LIST_RESULT_TYPES,
    payload: true
});

const listResultTypesSuccess = resultTypes => ({
    type: LIST_RESULT_TYPES_SUCCESS,
    payload: resultTypes
});

const listResultTypesError = error => ({
    type: LIST_RESULT_TYPES_ERROR,
    payload: error
});

//ADD AUDIENCE MOTIVE
export function addResultTypesAction(showForm) {
    return (dispatch) => {
        //Inicializo
        dispatch( addResultTypes(false) );
        //Abro el formulario
        showForm();
    }
}

const addResultTypes = isEdit => ({
    type: ADD_RESULT_TYPES,
    payload: isEdit
});

//SAVE AUDIENCE MOTIVE
export function saveResultTypesAction(resultType, handleClose) {
    return async (dispatch) => {
        //Inicializo
        dispatch( saveResultTypes() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.post(`/${controller}`, resultType);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( saveResultTypesSuccess(response.data) );
            //Cierro la ventana
            handleClose();
            //Mensaje
            SuccessMessage(MSG_CREATE_SUCCESS);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( saveResultTypesError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const saveResultTypes = () => ({
    type: SAVE_RESULT_TYPES,
    payload: true
});


const saveResultTypesSuccess = resultType => ({
    type: SAVE_RESULT_TYPES_SUCCESS,
    payload: resultType
});

const saveResultTypesError = error => ({
    type: SAVE_RESULT_TYPES_ERROR,
    payload: error
});

//EDIT AUDIENCE MOTIVE
export function editResultTypesAction(resultType, showForm) {
    return async (dispatch) => {
        //Inicializo
        dispatch( editResultTypes(resultType) );
        //Abro el formulario
        showForm();
    }
}

const editResultTypes = resultType => ({
    type: EDIT_RESULT_TYPES,
    payload: resultType
});

//UPDATE AUDIENCE MOTIVE
export function updateResultTypesAction(resultType, handleClose) {
    return async (dispatch) => {
        //Inicializo
        dispatch( updateResultTypes() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.put(`/${controller}/${resultType.id}`, resultType);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( updateResultTypesSuccess(response.data) );
            //Cierro la ventana
            handleClose();
            //Mensaje
            SuccessMessage(MSG_UPDATE_SUCCESS);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( updateResultTypesError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const updateResultTypes = () => ({
    type: UPDATE_RESULT_TYPES,
    payload: true
});

const updateResultTypesSuccess = resultType => ({
    type: UPDATE_RESULT_TYPES_SUCCESS,
    payload: resultType
});

const updateResultTypesError = error => ({
    type: UPDATE_RESULT_TYPES_ERROR,
    payload: error
});

//DELETE AUDIENCE MOTIVE
export function deleteResultTypesAction(resultType) {
    return async (dispatch) => {
        //Inicializo
        dispatch( deleteResultTypes() );
        //Mensaje de Espera
        WaitingMessage(MSG_DELETING);
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            // const response = await clienteAxios.delete(`/${controller}/${resultType.id}`);
            const response = await clienteAxios.put(`/${controller}/${resultType.id}/${METHOD_DISABLED}`);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( deleteResultTypesSuccess(response.data) );
            //Oculto espera
            Swal.close();
            //Mensaje
            SuccessMessage(MSG_DELETE_SUCCESS);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( deleteResultTypesError(data) );
            //Oculto espera
            Swal.close();
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const deleteResultTypes = () => ({
    type: DELETE_RESULT_TYPES,
    payload: true
});

const deleteResultTypesSuccess = resultType => ({
    type: DELETE_RESULT_TYPES_SUCCESS,
    payload: resultType
});

const deleteResultTypesError = error => ({
    type: DELETE_RESULT_TYPES_ERROR,
    payload: error
});